import Resource from './common/resource';

class FormSubmissions extends Resource {
  path = 'form/submissions';

  onCreateOne({ commit }, { model, res }) {
    commit('update', { model, update: res.data, action: 'prepend' });

    if (res.data?.obj_id) {
      commit(
        'formRecords/adjustSubmissionsCount',
        { collectionId: res.data.obj_id, delta: 1 },
        { root: true }
      );
    }
  }

  onDeleteOne({ commit }, { model }) {
    commit('delete', model.id);

    if (model?.obj_id) {
      commit(
        'formRecords/adjustSubmissionsCount',
        { collectionId: model.obj_id, delta: -1 },
        { root: true }
      );
    }
  }
}

export default FormSubmissions;
